export function openMap(lat:string){
    window.open(`https://www.google.com/maps/place/${lat}`);
}